module.exports = __webpack_public_path__ + "img/edit_square.5e9b8c0b.svg";